app.service('ePaymentModal', function (console, loading, modal, cookie, front, pageConfig, kredytLineRedirect) {
	var config, type, orderNumber;
	// modul wykorzystywany w widokach 'order finalize view' oraz 'customer'
	// widoki powinny posiadac modale o nazwie modal-EPayment-error dostepny w pliku modal-epayment.jsp (include)

	function init(options) {
		config = pageConfig.getData(front.group());
		if (type !== "undefined" && orderNumber !== "undefined") {
			type = options.type;
			orderNumber = options.orderNumber;
		}
	}

	function ePaymentLoad(option) {
		init(option);

		if (type == 'Platnosci') {
			getPlatnosciForm();
		}
		if (type == 'PaymentModule') {
			createPaymentModuleTransaction();
		}
		if (type == 'TPay') {
			createTPayTransactionUsingRest();
		}
	}

	function createTPayTransactionUsingRest() {

		loading.start();
		$.ajax({
			url: '/orderpayment/tpay/transactions.ltr',
			method: 'POST',
			dataType: "json",
			contentType: 'application/json',
			data: JSON.stringify({
				orderNumber: orderNumber
			}),
			success: function (json) {

				if (json.error) {
					modal.alert('błąd płatności tPay');
					console.log(json.errorMessage)
				}
				else {
					loading.stop();
					processTPayTransactionCreated(json.url);
				}
			},
			error: function () {
				modal.alert('błąd komunikacji płatności tPay');
			}
		});
	}

	function processTPayTransactionCreated(tPaySecureUrl) {
		loading.start();
		try { UA.pageview('/order-finalize-tpay-button-clicked.bhtml'); } catch (e) { };

		$.ajax({
			url: '/changePaymentStatus.ltr',
			method: 'POST',
			dataType: 'json',
			data: {
				action: 'markTPayAsProcessed',
				orderNumber: orderNumber
			},
			success: function () {
				loading.redirect(tPaySecureUrl);
			},
			error: function () {
				modal.alert('błąd komunikacji połączenia tpay');
			}
		});
	}

	function getPlatnosciForm() {
		loading.start();
		$.ajax({
			url: '/orderpayment/payu/transactions.ltr',
			method: 'POST',
			dataType: 'json',
			contentType: 'application/json',
			async: false,
			data: JSON.stringify({
				orderNumber: orderNumber
			}),
			success: function (data) {
				platnosciFormSuccess(data);
			},
			error: function () {
				loading.stop();
				modal.open('modal-EPayment-error');
			}
		});
	}

	function platnosciFormSuccess(data) {
		if (data.error) {
			loading.stop();

			if (data.errorMessage.length == 0) {
				data.errorMessage = "Komunikat błędu 'Platnosci.pl processing error' jest pusty.";
			}

			modal.generate({
				id: 'ePayment-message',
				content: $.trim(data.errorMessage),
				buttons: [{
					text: front.isRwd ? 'Rozumiem' : 'OK',
					cssClass: front.isRwd ? 'btn btn-second' : '',
					click: function () {
						modal.close();
					}
				}],
				callbackClose: function () {
					loading.reload();
				}
			});
		} else {
			platnosciSubmit(orderNumber, data.redirectUrl);
		}
	}

	function platnosciSubmit(orderNumber, redirectUrl) {
		UA.pageview('/order-finalize-platnosci-button-clicked.bhtml');
		loading.start();
		$.ajax({
			url: '/changePaymentStatus.ltr',
			method: 'POST',
			dataType: 'json',
			async: true,
			data: {
				action: 'markPlatnosciAsProcessed',
				orderNumber: orderNumber
			},
			success: function (data) {
				console.log('ePaymentSubmit: OK -> Platnosci');
				window.location.href = redirectUrl;
			},
			error: function () {
				loading.stop();
				console.log('ePaymentSubmit: ERROR');
			}
		});
	}

	function createPaymentModuleTransaction() {
		loading.start();
		$.ajax({
			url: '/orderpayment/paymentmodule/transactions.ltr',
			method: 'POST',
			dataType: "json",
			data: {
				orderNumber: orderNumber
			},
			success: function (json) {

				if (json.error) {
					modal.alert('błąd płatności');
					console.log(json.errorMessage)
				}
				else {
					if (config.pageType == 'finalize') {
						window.location.href = '/order-payment-module.bhtml';
					} else {
						window.location.href = '/konto-platnosc.bhtml?orderNumber=' + orderNumber;
					}
				}
			},
			error: function () {
				modal.alert('błąd komunikacji płatności');
			}
		});
	}

	function goToInstalment(orderNumber, instalmentNumber) {
		config = pageConfig.getData(front.group());
		kredytLineRedirect.redirect({
			orderNumber
		}, {
			timeout: config.nklTimeout,
			revisions: config.nklRevisions
		});
	}

	return {
		init,
		load: ePaymentLoad,
		goToInstalment
	};
});
